import { render, staticRenderFns } from "./MonitorScoreExamShowMedia.vue?vue&type=template&id=3bd1f07d&"
import script from "./MonitorScoreExamShowMedia.vue?vue&type=script&lang=js&"
export * from "./MonitorScoreExamShowMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports